import { Routes, Route } from 'react-router-dom'

import { AddTaskFormScreen } from '@screens/Task/containers/TaskSection/FormScreens/Forms/AddTask'
import { AddTaskProvider } from '@screens/Task/containers/TaskSection/FormScreens/Forms/AddTask/AddTaskContext'
import { AddDummyAssignmentFormScreen } from '@screens/Task/containers/TaskSection/FormScreens/Forms/AddTask/DummyAssignment/AddDummyAssignment'
import { EditDummyAssignmentFormScreen } from '@screens/Task/containers/TaskSection/FormScreens/Forms/AddTask/DummyAssignment/EditDummyAssignment'

export type AddTaskParamsList = {
  addTaskFormScreen: { jobId: number }
  addDummyAssignmentFormScreen: undefined
  editDummyAssignmentFormScreen: { dummyAssignmentId: string }
}

export function AddTaskRoutes() {
  return (
    <AddTaskProvider>
      <Routes>
        <Route path="/" element={<AddTaskFormScreen />} />
        <Route
          path="/add-dummy-assignment/:duration"
          element={<AddDummyAssignmentFormScreen />}
        />
        <Route
          path="/edit-dummy-assignment/:dummyAssignmentId"
          element={<EditDummyAssignmentFormScreen />}
        />
      </Routes>
    </AddTaskProvider>
  )
}
